import { render, staticRenderFns } from "./TipoMedida.vue?vue&type=template&id=9d7100ae&"
import script from "./TipoMedida.vue?vue&type=script&lang=ts&"
export * from "./TipoMedida.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports